import { render, staticRenderFns } from "./SideBarProfile.vue?vue&type=template&id=7b2eb7e5&scoped=true&"
import script from "./SideBarProfile.vue?vue&type=script&lang=js&"
export * from "./SideBarProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2eb7e5",
  null
  
)

export default component.exports